<div class="row">
  <div class="col-12">
    <h4>{{ user }}’s Upcoming {{ selectedSport }} Picks</h4>
    <div class="bg-white p-3 rounded-10">
      <div class="kingpin-table">
        <div class="table-row header blue">
          <div class="cell">Match date</div>
          <div class="cell">Game</div>
          <div class="cell">Pick</div>
          <div class="cell">Amount</div>
          <div class="cell text-md-center">Amount to be won</div>
        </div>

        <div class="table-row" *ngFor="let item of upcomingPicks">
          <div class="cell" data-title="Match date">{{ item.match_date }}</div>
          <div class="cell" data-title="Game">
            {{ item.teams }}
          </div>
          <div class="cell" data-title="pick">
            <ng-container
              *ngIf="
                authuserId == userId || (_user.subscribed | async);
                else noSubscribe
              "
            >
              {{ item.team_bet }}
            </ng-container>
            <ng-template #noSubscribe>
              <a class="btn btn-theme btn-sm" routerLink="/subscription"
                >Upgrade</a
              >
            </ng-template>
          </div>
          <div class="cell" data-title="Amount">
            {{ item.bet_amount | CustomCurrency }}
          </div>
          <div class="cell text-md-center" data-title="Amount to be won">
            <ng-container
              *ngIf="
                authuserId == userId || (_user.subscribed | async);
                else noSubscribe
              "
            >
              {{ item.potential_win | CustomCurrency }}
            </ng-container>
          </div>
        </div>
      </div>
      <div class="mt-3" *ngIf="!upcomingPicks?.length">
        <small class="text-center d-block">
          {{ authuserId == userId ? 'You have' : 'The User has' }} not put any picks in
          {{ selectedSport ? "for " + selectedSport : "" }}, please check back
          later for picks.
          <br />
          You can also Follow this user to receive pick notifications to your
          email.
        </small>
      </div>
    </div>
  </div>
</div>
